module.exports = __webpack_public_path__ + "img/icon-apple.eab94270.svg";